import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';

import { LoadingSpinner } from '../../../shared/ui';
import {
  AdminBlogShell,
  AdminContentEditorFields,
  AdminPageHeader,
  appendYowanContentPreviewQuery,
  usePreservedDomainSearch,
} from './AdminBlogListPage';
import {
  createYowanAdminNews,
  getYowanApiFieldErrorMessage,
  getYowanAdminMutationErrorMessage,
} from '../app/yowanContentClient';
const { yowanPageContent } = require('./pageContent');

const AdminNewsCreatePage = () => {
  const content = yowanPageContent['/admin/content/news/new'];
  const navigate = useNavigate();
  const preservedDomainSearch = usePreservedDomainSearch();
  const [submitMessage, setSubmitMessage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const {
    register,
    handleSubmit,
    setError,
    formState: { errors },
  } = useForm({
    defaultValues: content?.form.defaults,
  });

  if (!content) {
    return null;
  }

  const onSubmit = async (formValues) => {
    setIsSubmitting(true);
    setSubmitMessage('');

    try {
      const created = await createYowanAdminNews(formValues);
      setSubmitMessage('保存しました。');
      if (created?.id) {
        navigate(appendYowanContentPreviewQuery('/admin/content/news', preservedDomainSearch));
      }
    } catch (error) {
      const slugMessage = getYowanApiFieldErrorMessage(error, ['slug']);

      if (slugMessage) {
        setError('slug', { type: 'server', message: slugMessage });
        setSubmitMessage('slugを確認してください。');
      } else {
        setSubmitMessage(getYowanAdminMutationErrorMessage(error));
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AdminBlogShell activeNavHref="/admin/content/news" routeKey="/admin/content/news/new">
      <AdminPageHeader
        title={content.header.title}
        paragraphs={content.header.paragraphs}
        actions={[
          <Link key="back-to-list" to={appendYowanContentPreviewQuery('/admin/content/news', preservedDomainSearch)}>
            一覧へ戻る
          </Link>,
        ]}
      />

      <form className="yowan-admin-form c-surface-content" onSubmit={handleSubmit(onSubmit)}>
        <AdminContentEditorFields
          content={content}
          register={register}
          errors={errors}
          showSlugField
          slugRequired={false}
        />

        <div className="yowan-admin-form__actions">
          <button type="submit" className="c-form__submit" disabled={isSubmitting}>
            {content.form.submitLabel}
          </button>
        </div>

        {isSubmitting ? (
          <p className="yowan-admin-form__message yowan-admin-form__message--pending">
            <LoadingSpinner inline size="sm" />
            <span>{content.form.pendingMessage}</span>
          </p>
        ) : submitMessage ? (
          <p className="yowan-admin-form__message">{submitMessage}</p>
        ) : null}
      </form>
    </AdminBlogShell>
  );
};

export default AdminNewsCreatePage;
